import * as React from 'react'
import styled from '@emotion/styled'

import Fade from 'react-reveal/Fade';
import { fonts } from '../../styles/variables'

import LocalizedLink from '../links/LocalizedLink'
import ShImg1 from './sh/ShImg1'
import ZkittlezImg2 from './zkittlez/ZkittlezImg2'
import AhImg2 from './alien-haze/AhImg2'
import ZkittlezImg3 from './zkittlez/ZkittlezImg3'
import AhImg3 from './alien-haze/AhImg3'



const LilaCartThumb = styled.div`
width:360px;
height:auto;
transition:all .4s ease;
display:flex;
padding-left: 1rem;
align-items:center;



`

const LilaProductInfo = styled.div`
width:100%;
display:flex;
align-items:center;
padding-left:18px;


`

const Img = styled.div`
width:50px;
height:auto;
margin-right:20px;

`



const LilaItemCol = styled.div`
width:70px;
display:flex;
justify-content:flex-end;

`


const LilaItemTitle = styled.div`
width:200px;
`




const LilaTitle = styled.div`
display:flex;
align-items:center;
font-family:${fonts.bcExtraLight};
`

const Title = styled.div`
font-family:${fonts.bcExtraLight};

`
const Num = styled.div`
width:40px;
`


const SubTitle = styled.div`
margin-left:1rem;
opacity:.5;
`

const LilaSum = styled.div`
display:flex;
align-items:center;
width:50px;
justify-content:flex-end;
font-family:${fonts.bcExtraLight};
`


const LilaMargin = styled.div`

`



class CartOverviewThumb extends React.Component {
  constructor(props: any) {
    super(props)
    this.state = {

    }
  }



  componentDidMount() {

  }

  render() {
    return(

      <Fade top>
        <LilaMargin></LilaMargin>
        <LilaCartThumb >

          { this.props.itemID === '001'&&
          <Img>
            <ZkittlezImg2/></Img>
          }

          {this.props.itemID === '002'&&
          <Img>
            <ZkittlezImg3/></Img>
          }
          {this.props.itemID === '003'&&
          <Img>
            <AhImg2/></Img>
          }
          {this.props.itemID === '004'&&
          <Img>
            <AhImg3/></Img>
          }
          {this.props.itemID === '005'&&
          <Img>
            <ShImg1/></Img>
          }
          {this.props.itemID === '006'&&
          <Img>
            <ShImg1/></Img>
          }

          <LilaItemTitle>
            <LilaTitle> <Num>{this.props.quantity + 'x'}</Num><LocalizedLink to={this.props.link}> <Title>{this.props.title}</Title> </LocalizedLink><SubTitle>{this.props.subTitle}</SubTitle></LilaTitle>
        </LilaItemTitle>

          <LilaItemCol>
<LilaSum>
  {this.props.price*this.props.quantity}€
</LilaSum>


          </LilaItemCol>


        </LilaCartThumb>
      </Fade>


    )
  }
}


export default CartOverviewThumb


//<P><Zoom delay={4200} right cascade>CBD BLÜTEN</Zoom></P>
